import styled from "@emotion/styled";

export const RouteCircle = styled.div<{
  colors: string[];
  climbType?: "BOULDER" | "SPORT";
  size?: number;
}>`
  width: ${({ size }) => (size ? `${size}px` : "20px")};
  height: ${({ size }) => (size ? `${size}px` : "20px")};
  border-radius: ${({ climbType }) => (climbType === "SPORT" ? "20%" : "100%")};
  box-shadow:
    0 0 2px #00000055,
    0 0 0 1px inset #00000011;
  position: relative;
  background: ${({ colors }) => getRepeatingColorsBg(colors)};
  flex-shrink: 0;
`;

export const getRepeatingColorsBg = (colors: string[]) => {
  const list = colors.map((color, index) => {
    return `${color} ${(index * 100) / colors.length}%, ${color} ${
      ((index + 1) * 100) / colors.length
    }%`;
  });

  return `
    repeating-linear-gradient(
      -45deg,
      ${list.join(",")}
    )
  `;
};
